import React, { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useLanguage } from '../contexts/LanguageContext';

export function Tabs({ activeTab, onTabChange }) {
  const posthog = usePostHog();
  const { t, lang, setLang } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  // Icon can be: { svg: '/path/to/icon.svg' } or { emoji: '💎' } or just emoji string for backwards compat
  const tabs = [
    { id: 'augment', icon: { svg: '/icons/augment.cropped.svg', emoji: '💎' }, label: t('tabAugment') },
    { id: 'skill', icon: { svg: '/icons/simplebook.svg', emoji: '📚' }, label: t('tabSkill') },
    { id: 'enchant', icon: { svg: '/icons/scroll-enchant-weapon.svg', emoji: '📜' }, label: t('tabEnchant') },
    { id: 'equipment', icon: { svg: '/icons/compare.cropped.svg', emoji: '⚔️' }, label: t('tabEquipment') },
    { id: 'wiki', icon: { svg: '/icons/wiki.cropped.svg', emoji: '📖' }, label: t('tabWiki') },
    { id: 'simulator', icon: { svg: '/icons/simulator.cropped.svg', emoji: '🎰' }, label: t('tabSimulator'), style: { paddingLeft: '19px' } },
  ];

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  const closeMenu = () => {
    document.activeElement?.blur();
    setMenuOpen(false);
  };

  const handleTabSelect = (tabId) => {
    posthog.capture('$pageview', { tab: tabId });
    onTabChange(tabId);
    closeMenu();
  };

  // Render icon - SVG with mask for color inheritance, or emoji fallback
  const renderIcon = (icon, className) => {
    if (icon?.svg) {
      return (
        <span
          className={`${className} svg-icon`}
          style={{ maskImage: `url(${icon.svg})`, WebkitMaskImage: `url(${icon.svg})` }}
        />
      );
    }
    return <span className={className}>{icon?.emoji || icon}</span>;
  };

  return (
    <>
      {/* Bottom bar - whole bar opens menu */}
      <div className="tabs-bar" onClick={() => setMenuOpen(true)}>
        <span className="hamburger-icon">☰</span>
        <div className="current-tab-center">
          {renderIcon(activeTabData?.icon, 'tab-icon')}
          <span className="current-tab-label">{activeTabData?.label}</span>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && (
        <div className="menu-overlay" onClick={closeMenu} />
      )}

      {/* Slide-out menu */}
      <div className={`slide-menu ${menuOpen ? 'open' : ''}`}>
        <div className="slide-menu-header">
          <span>{t('menuTitle') || 'Menu'}</span>
          <button className="close-btn" onClick={closeMenu}>×</button>
        </div>
        <div className="slide-menu-items">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`menu-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabSelect(tab.id)}
              style={tab.style}
            >
              {renderIcon(tab.icon, 'menu-item-icon')}
              <span className="menu-item-label">{tab.label}</span>
            </button>
          ))}
        </div>
        <div className="menu-lang-section">
          <span
            className="menu-lang-icon svg-icon"
            style={{ maskImage: 'url(/icons/globe.svg)', WebkitMaskImage: 'url(/icons/globe.svg)' }}
          />
          <div className="menu-lang-buttons">
            <button
              className={`menu-lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
            <button
              className={`menu-lang-btn ${lang === 'ru' ? 'active' : ''}`}
              onClick={() => setLang('ru')}
            >
              RU
            </button>
            <button
              className={`menu-lang-btn ${lang === 'ua' ? 'active' : ''}`}
              onClick={() => setLang('ua')}
            >
              UA
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
